export default function  searchMultiple (search, colValue) {
    return search.some(termino => colValue.toLowerCase().includes(termino.toLowerCase()));
};